import { lazy } from "react";
import url from "src/config/search.json";

const LatLongToPointPage = lazy(
  () => import("src/pages/map-display/lat-long-to-point")
);
const DrawerToPage = lazy(() => import("src/pages/map-display/Drawer-to"));

const PrintToPage = lazy(() => import("src/pages/map-display/Print-to"));
const keys = Object.keys(url.services);
const currentkey = keys[3];

export const generalRoutes = [
  {
    path: currentkey,

    children: [
      { path: url.services.General[2].url, element: <LatLongToPointPage /> },
      {
        path: url.services.General[0].url,
        element: <DrawerToPage />,
      },
      { path: url.services.General[1].url, element: <PrintToPage /> },
    ],
  },
];
